import { useContext } from 'react';

import { Device } from '../EditingContext';

export default function useDeviceContext() {
  return useContext(Device);
}
